import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;

const coreBlue = colors.ui.core[25];
const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[600];
const greyExtraLight = colors.ui.neutral[25];

const { fontSize, text2Obj, heading5Obj } = typographyStyles;

export const dateCss = [
  fontSize.textXS,
  {
    color: colors.ui.neutral[400],
    margin: 0,
  },
];

export const questionTextCss = {
  ...text2Obj,
  color: greyDark,
  margin: "0 0 48px",
  wordBreak: "break-word",

  "& > p:last-of-type": {
    marginBottom: "0",
  },
};

const responseAreaCss = {
  ...text2Obj,
  color: grey,
  width: "100%",
  maxWidth: "100%",
  margin: "16px 0 40px",
  padding: "12px 12px 12px 16px",
  border: "none",
  borderRadius: "8px",
  p: {
    margin: 0,
    wordBreak: "break-word",
  },
};

export const studentResponseAreaCss = {
  ...responseAreaCss,
  background: coreBlue,
};

export const teacherResponseAreaCss = {
  ...responseAreaCss,
  background: greyExtraLight,
};

export const headingCss = {
  ...heading5Obj,
  display: "block",
  color: greyDark,
  fontWeight: "bold",
  margin: "0 0 16px 0",
};
